// @flow
import * as React from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as selectors from '../../modules/selectors';
import Plus from '../Icons/Plus';
import colors from '../../assets/css/colors';
import Revert from '../Icons/Revert';
import Padlock from '../Icons/Padlock';
import {
	TeamUserAvatar,
	TeamUserAvatarWrapper,
	TeamName,
	LoadingSpinner,
	TableGrid,
	TableFlexHeading,
	TableFlexBody,
	TableFlexRow,
	PlayerTableCell,
	RotatedLabel,
	PlayerInfo,
	BenchTitle,
	FilledIcon,
	DraftTableHeader,
	TeamSelect,
	EmptyTeamTable,
	ThToolTip,
	CoachLockIcon
} from '../';
import { getSquadSize } from '../../helpers/league';
import type { TTeamsDraftTradesReducer, TCoachStatsListReducer } from '../../modules/types';
import { team_trade_coach_player_stats } from '../../helpers/stats';
import { getLineupPlayersCount } from '../../helpers/complex/team';

const TableFlexRowStyled = styled(TableFlexRow)`
	.coach {
		color: ${colors.coachPurple};
	}
	${({ is_on_trade, is_user }) => is_on_trade && `
			background: ${colors.lightGrey};
			box-sizing: border-box;
			border: 2px solid ${is_user ? `#D0021B`:`#7ED321`};
			> div {
				opacity: .5;
			}
			> div:first-child {
				opacity: 1;

				> div:first-child {
					opacity: 1;
				}
				> div {
					opacity: .5;
				}
			}
			> div:last-child {
				opacity: 1;
			}
		`};
`;
type TableRow = { key: string, prop?: string, prop_sub?: string, is_fc?: boolean, tooltip: string };
type TTableColumns = Array<TableRow>;

type Props = {
	team: Object,
	team_id: number,
	league: Object,
	table: {
		basic: TTableColumns,
		coach: TTableColumns,
	},
	actual_round: Object,
	lineup_players: Object,
	emergency_arr: Array<number>,
	addInTrade: Function,
	addOutTrade: Function,
	removeInPlayer: Function,
	removeOutPlayer: Function,
	team_trade: TTeamsDraftTradesReducer,
	is_league_started: boolean,
	has_assistant_coach: boolean,
	coach_stats_list: TCoachStatsListReducer,
	is_user: boolean,
	teams_by_id: Object,
	handleTeamSelect?: Function,
	empty_lineup: Object,
	changeView: Function
};

type State = {
	is_coach_active: boolean,
	coach_type: string,
};

export class TeamForTradePage extends React.Component<Props, State> {
	state = {
		is_coach_active: false,
		coach_type: 'coaches-choice',
	};
	static defaultProps = {
		players: [],
		table: {
			basic: [
				{ key: 'GP', prop: 'stats.games_played', tooltip: '	Games Played' },
				{ key: 'AVG', prop: 'stats.avg_points', tooltip: 'Average Points' },
				{ key: 'TP', prop: 'stats.total_points', tooltip: 'Total Points' },
				{ key: 'PROJ', prop: 'stats.proj_score_actual_round', is_fc: true,
					tooltip: 'Project Score' },
			],
			coach: _.mapValues(team_trade_coach_player_stats, values => _.map(values, value => {
				return {
					...value,
					is_fc: true
				};
			}))
		},
		team: {},
		teams_by_id: {}
	};
	constructor(props: Props, state: State) {
		super(props, state);

		_.bindAll(this, [
			'getTableSection',
			'getTableRow',
			'handleCoachSelectChange',
			'onTabChange',
			'setCoachType',
			'isCanTrade'
		]);
	}
	get user_team() {
		return (
			<React.Fragment>
				<TeamUserAvatarWrapper height="80px">
					{this.team_data}
				</TeamUserAvatarWrapper>
				{this.team_table}
			</React.Fragment>
		);
	}
	get team_table() {
		return (
			<div>
				{this.draft_table_header}
				<TableGrid>
					{this.table_header}
					{this.table_body}
				</TableGrid>
			</div>
		);
	}
	get empty_team_table() {
		const { empty_lineup } = this.props;
		return <EmptyTeamTable empty_lineup={empty_lineup} />;
	}
	get league_teams() {
		const { team_id } = this.props;

		return (
			<React.Fragment>
				<TeamUserAvatarWrapper height="80px">
					{this.team_select}
					{/* {team_id ? (
						<React.Fragment>
							{this.team_size}
						</React.Fragment>
					): null} */}
				</TeamUserAvatarWrapper>
				{team_id ? this.team_table : this.empty_team_table}
			</React.Fragment>
		);
	}
	get team_select() {
		const { teams_by_id, team_id, handleTeamSelect } = this.props;
		if (_.isEmpty(teams_by_id)) {
			return null;
		}

		const { user_id = 0, avatar_version = 0 } = _.find(
			teams_by_id, ({ id }) => team_id === id
		) || {};

		return (
			<React.Fragment>
				<TeamUserAvatar user_id={user_id} avatar_version={avatar_version} />
				<TeamSelect value={team_id} handleTeamSelect={handleTeamSelect}>
					<option value="0">Select a team to trade with</option>
					{_.map(teams_by_id, ({ id, name }) => (
						<option key={id} value={id}>
							{name}
						</option>
					))}
				</TeamSelect>
			</React.Fragment>
		);
	}
	get draft_table_header() {
		const { is_coach_active } = this.state;
		const { coach_stats_list, actual_round: { status } } = this.props;

		if (status === 'complete') {
			if (is_coach_active) {
				this.setState({
					is_coach_active: false
				});
			}
			return null;
		}
		return (
			<DraftTableHeader
				onTabClick={this.onTabChange}
				isCoachActive={is_coach_active}
				selectOptions={coach_stats_list}
				setCoachType={this.setCoachType}
				onSelectChange={this.handleCoachSelectChange}
			/>
		);
	}
	get team_data() {
		const { team } = this.props;

		if (_.isEmpty(team)) {
			return null;
		}
		return (
			<React.Fragment>
				<TeamUserAvatar user_id={team.user_id} avatar_version={team.avatar_version} />
				<TeamName>
					{team.name}
				</TeamName>
			</React.Fragment>
		);
	}
	get team_size() {
		const { team, league } = this.props;

		if (_.isEmpty(team) || _.isEmpty(league)) {
			return null;
		}
		const { lineup } = team,
			current = getLineupPlayersCount({ lineup }),
			total = getSquadSize(league);

		return (<p>{current}/{total}</p>);
	}
	get table_keys() {
		const { is_coach_active, coach_type } = this.state;
		return is_coach_active ?
			_.get(this.props, `table.coach[${coach_type}]`) :
			this.props.table.basic;
	}
	get table_header() {
		const cells = _.map(this.table_keys, ({ key, prop, is_fc, tooltip }) => (
			<PlayerTableCell key={key}
				width="50px"
				height="50px"
				basis="15%"
				className={this.getRowClassNames({ key, is_fc, tooltip })}
			>
				<span className="column-name">{key}</span>
				<ThToolTip text={tooltip} />
			</PlayerTableCell>
		));

		return (
			<TableFlexHeading height="50px" is_coach={this.state.is_coach_active}>
				<PlayerTableCell width="180px" justify="flex-start">
					Your team
				</PlayerTableCell>
				{ cells }
				<PlayerTableCell width="60px">
					ADD TO<br />TRADE
				</PlayerTableCell>
			</TableFlexHeading>
		);
	}
	get table_body() {
		const { team, lineup_players } = this.props;
		const { lineup } = team;

		if (!lineup || _.isEmpty(lineup_players)) {
			return <LoadingSpinner />;
		}
		const lineup_pure = _.omit(lineup, ['captain', 'vice_captain', 'bench', 'emergency']);
		const bench = _.get(lineup, 'bench');

		return (
			<TableFlexBody>
				{_.map(lineup_pure, this.getTableSection)}
				<BenchTitle>
					Bench
				</BenchTitle>
				{_.map(bench, id => this.getTableRow(
					{ id, is_bench: true, is_agent: false }
				))}
			</TableFlexBody>
		);
	}
	getTableSection(line: Array<number>) {
		return line.map(id => this.getTableRow({
			id,
			is_bench: false
		}));
	}
	getTableRow({ id, is_bench }: Object) {
		const {
				lineup_players,
				league,
				team: { lineup: { captain, vice_captain } },
				emergency_arr,
				team_trade,
				has_assistant_coach,
				is_user
			} = this.props,
			is_on_trade = team_trade[is_user ? 'old_player_id' : 'new_player_id'].includes(id),
			player = lineup_players[id],
			is_captain = captain === id,
			is_vice_captain = vice_captain === id,
			is_emergency_enabled = league.emergency && is_bench,
			is_emergency = emergency_arr ? emergency_arr.includes(id) : false;

		if (!player) {
			return (
				<TableFlexRow key={id}>
					<LoadingSpinner />
				</TableFlexRow>
			);
		}

		return (
			<TableFlexRowStyled key={id} is_on_trade={is_on_trade} is_user={is_user}>
				<PlayerTableCell width="180px" height="60px" justify="flex-start">
					<RotatedLabel
						is_on_trade={is_on_trade}
						is_captain={is_captain}
						is_vice_captain={is_vice_captain}
						is_emergency_enabled={is_emergency_enabled}
						is_emergency={is_emergency}
						text={player.position_in_lineup}
						rotate="-90" />
					<PlayerInfo short_opponent player={player} />
				</PlayerTableCell>
				{_.map(this.table_keys, ({ key, prop, prop_sub, is_fc, tooltip }) => {
					const renderValue = () => (
						<React.Fragment>
							{_.get(player, prop, '--')} {prop_sub
								? `(${_.get(player, prop_sub, '--')})`
								: null
							}
						</React.Fragment>
					);
					return (
						<PlayerTableCell key={key} width="50px" height="60px" basis="15%"
							className={this.getRowClassNames({ key, is_fc, tooltip })}
						>
							{ is_fc && !has_assistant_coach ? (
								<CoachLockIcon size=".875" />
							) : renderValue()}
						</PlayerTableCell>
					);
				})}
				{this.getControls({ id })}

			</TableFlexRowStyled>
		);
	}

	getControls({ id }: Object) {
		const {
			removeInPlayer,
			removeOutPlayer,
			addInTrade,
			addOutTrade,
			team_trade,
			is_user
		} = this.props;
		const is_on_trade = team_trade[is_user ? 'old_player_id' : 'new_player_id'].includes(id);

		if (!this.isCanTrade({ id })) {
			return (
				<PlayerTableCell
					position="relative"
					width="60px"
					height="60px"
				>
					<Padlock color={colors.icon_grey} />
				</PlayerTableCell>
			);
		}

		return is_on_trade ? (
			<PlayerTableCell
				position="relative"
				width="60px"
				height="60px"
				onClick={() => is_user ? removeOutPlayer({ id }) : removeInPlayer({ id })}
			>
				<FilledIcon
					background={colors.red}
					className="filled-icon"
				>
					<Revert color="#fff" />
				</FilledIcon>
			</PlayerTableCell>
		) : (
			<PlayerTableCell
				position="relative"
				width="60px"
				height="60px"
				onClick={() => is_user ? addOutTrade({ id }) : addInTrade({ id })}
			>
				<Plus color={colors.nrlDarkGreen} />
			</PlayerTableCell>
		);
	}
	// Helpers
	getRowClassNames({ key, is_fc }: TableRow) {
		let class_name = '';
		if (key !== 'avg') {
			class_name += ' hidden-mobile';
		}
		if (is_fc) {
			class_name += ' coach';
		}
		return class_name;
	}
	isCanTrade({ id }: Object) {
		const {
				league: { lockout },
				is_league_started,
				lineup_players,
				team: { lineup: { captain, vice_captain } },
				actual_round: { status }
			} = this.props,
			is_not_scheduled_round = status !== 'scheduled',
			player = lineup_players[id],
			is_captain = captain === id,
			is_vice_captain = vice_captain === id,
			is_locked = player.locked || is_captain || is_vice_captain,
			is_lockout = lockout ? (is_not_scheduled_round && is_locked) : is_not_scheduled_round;
		if (!is_league_started) {
			return true;
		}

		return !is_lockout;
	}

	//Handlers
	handleCoachSelectChange(event: Object) {
		const { value: coach_type } = event.target;
		this.setState({ coach_type });
	}
	onTabChange(){
		const { is_coach_active } = this.state;
		this.setState({ is_coach_active: !is_coach_active });
	}
	setCoachType(event: Object) {
		const { value } = event.target;
		this.setState({ coach_type: value });
	}

	render() {
		const { is_user, changeView } = this.props;
		return (
			<div onClick={() => changeView ? changeView(is_user) : null}>
				{is_user ? this.user_team : this.league_teams}
			</div>
		);
	}
}

const mapStateToProps = (state, props) => {
	const { team_id } = props;
	const current_user_id = state.user.data.id;
	const teams_by_id = _.filter(
		selectors.complex.team.getTeamsWithFullLineup(state, props),
		({ user_id }) => user_id !== current_user_id
	);
	return {
		teams_by_id,
		user_id: current_user_id,
		empty_lineup: selectors.complex.team.getEmptyLineup(state, props),
		isPending: state.leagues.show.isPending,
		team: selectors.complex.team.getSelectedTeam(state, team_id),
		has_assistant_coach: Boolean(selectors.getUser(state).assistant_coach),
		actual_round: selectors.rounds.getSelectedRound(state),
		lineup_players: selectors.complex.team.getLineupPlayers(state, team_id),
		emergency_arr: selectors.complex.team.getEmergencyArray(state),
		is_league_started: selectors.leagueDraft.isLeagueStarted(state, props),
		coach_stats_list: state.coachStatsList
	};
};

export const TeamForTeamToTeamTrade = withRouter(
	connect(mapStateToProps)(TeamForTradePage)
);

export default TeamForTeamToTeamTrade;


// WEBPACK FOOTER //
// ./src/components/Team/TeamForTeamToTeamTrade.js